import script from "./LegalPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalPage.vue?vue&type=script&setup=true&lang=js"

import "./LegalPage.vue?vue&type=style&index=0&id=04dee1b8&scoped=true&lang=css"

import exportComponent from "D:\\_A-Project\\KoManga\\Ko-Manga-Center-Ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04dee1b8"]])

export default __exports__